import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { showToast } from "../../utils/toastUtils";
import "./ForgotPasswordPage.css";
import loginBgImage from "../../assets/images/Login_Page_bg.png";
import logoImage from "../../assets/images/LogoImage.svg";
import { callApi } from "../../utils/apiService";
import { videoCreatorEndPoint } from "../../Constants/constants";
import { useUser } from "../../Context/UserContext";

const ForgotPasswordPage = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { setPasswordResetData } = useUser();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "email") {
      setEmailError("");
    }
  };

  const validateEmail = () => {
    const email = formData.email.trim();

    if (!email) {
      setEmailError("Email is required");
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      return false;
    }

    setEmailError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail()) {
      return;
    }

    setLoading(true);
    try {
      const response = await callApi(
        `${videoCreatorEndPoint}auth/forgot-password-otp`,
        "POST",
        {
          email: formData.email,
        }
      );

      if (response.status) {
        // Store email in context for next steps
        setPasswordResetData({ email: formData.email });

        // Show success toast
        showToast("success", "OTP sent successfully", 100);

        // Navigate to verify-code page
        setTimeout(() => {
          navigate("/verify-code");
        }, 1000);
      } else {
        showToast("error", response.alert || response.message || "Failed to send OTP");
      }
    } catch (error) {
      showToast("error", error.message || "Failed to send OTP. Please try again.");
      console.error("Forgot password error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div
        className="login-left"
        style={{ backgroundImage: `url(${loginBgImage})` }}
      >
        <div className="mobile-wave">
          <svg
            className="mobile-wave-svg"
            viewBox="0 0 1440 320"
            preserveAspectRatio="none"
          >
            <path
              fill="#f5f5f5"
              d="M0,224L80,202.7C160,181,320,139,480,154.7C640,171,800,245,960,250.7C1120,256,1280,192,1360,160L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
            />
          </svg>
        </div>
      </div>
      {/* MID CURVE (SEPARATE ELEMENT) */}
      <div className="mid-curve">
        <svg
          className="mid-curve-svg"
          viewBox="0 0 520 1000"
          preserveAspectRatio="none"
        >
          <path
            d="
              M 520 0
              L 270 0
              C 220 70, 205 140, 245 210
              C 310 330, 175 430, 140 520
              C 100 640, 260 730, 275 840
              C 290 930, 225 1000, 170 1000
              L 520 1000
              Z
            "
            fill="#f5f5f5"
          />
        </svg>
      </div>

      {/* Right side */}
      <div className="login-right">
        <div className="login-card">
          <div className="login-logo">
            <img src={logoImage} alt="AstroCure" className="login-logo-image" />
          </div>

          <h1 className="login-title">Welcome To AstroCure!</h1>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <div className="fg-pass-text">Forgot Password</div>
              <div className="fg-pass-desc">Please enter the email associated with your account. A verification code will be sent to your inbox. If you don’t remember your email, contact our support team.</div>
              <div className="floating-group">
                <label htmlFor="email" className="frgt-floating-label">
                  Email-ID <span className="required">*</span>
                </label>

                <input
                  type="email"
                  id="email"
                  name="email"
                  className={`form-input floating-input ${emailError ? "form-input-error" : ""}`}
                  placeholder="Enter your Email id"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  disabled={loading}
                />
                {emailError && <p className="frgt-error">{emailError}</p>}
              </div>
            </div>

            <button type="submit" className="verification-button" disabled={loading}>
              {loading ? "Sending..." : "Send verification Code"}
            </button>
            <button type="button" onClick={() => { navigate("/login");}} className="frgt-back-button" disabled={loading}>
              Back to Login
            </button>
          </form>
        </div>

        <footer className="login-footer">
          Copyright © 2026 Astrovidhi Private Limited All rights reserved
        </footer>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
